<div class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden bg-card dark:bg-default">
    <div
        class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
        fuseScrollReset>
        <div
            class="flex flex-col flex-0 w-full shadow overflow-hidden bg-card dark:bg-black dark:bg-opacity-10">
            <div class="flex flex-col">

                <!-- Componente para mostrar mapa debe emitir las cordenadas cada que se actualiza el marker en el mapa -->
                <mapas-container *ngIf="this.typeUI === 'georeferencia' || this.typeUI === 'evk-google-maps'"
                                 [config]="paso" [paso]="paso" (updatePositionMarker)="resultObject.next($event)">
                </mapas-container>

                <!-- Componente para adjuntar y mostar documentos-->
                <lib-documentos *ngIf="paso?.ui === 'documentos-proyecto'"
                                [expediente]="expediente"
                                [expedienteConfig]="paso?.inData?.expedienteConfig"
                                [config]="paso"
                                [readOnly]="readOnly"
                                (resultObject)="onDoneForm($event)"
                                [descargaZipByFolio]="descargaZipByFolio"
                                [skipByVersion]="skipByVersion"
                >
                </lib-documentos>

                <!-- Componenete para mostrar fomulario dinamico -->
                <seaged-form-factory *ngIf="this.typeUI == 'metadata'" [form]="form"
                                     [idNegocio]="paso?.metadataFormId"
                                     (onDoneForm)="onDoneForm($event)"
                                     [actionsFields]="this.actionsField"></seaged-form-factory>

                <lib-solicitud-firma
                    *ngIf="paso?.ui === 'solicitud-firma'"
                    [expediente]="expediente"
                    [config]="paso">
                </lib-solicitud-firma>

                <lib-solicitud-pago
                    *ngIf="paso?.ui === 'solicitud-pago'"
                    [expediente]="expediente"
                    (resultObject)="onDoneForm($event)"
                    [config]="paso">
                </lib-solicitud-pago>

                <lib-expediente-detalle
                    [expediente]="expediente"
                    [expedienteConfig]="expediente?.configuracionExpediente"
                    *ngIf="paso?.ui === 'detalle'">
                </lib-expediente-detalle>

            </div>
        </div>
    </div>
</div>
